export function roundToDecimals(value: number, decimals: number): string {
  const roundingFactor = 10 ** decimals;
  return parseFloat((Math.round(value * roundingFactor) / roundingFactor).toFixed(decimals)).toString();
}

export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
